import { render, staticRenderFns } from "./DetailExternal.vue?vue&type=template&id=2208a32e&"
import script from "./DetailExternal.vue?vue&type=script&lang=js&"
export * from "./DetailExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports